import { render } from "./ButtonRed.vue?vue&type=template&id=6fdbba67&scoped=true&ts=true"
import script from "./ButtonRed.vue?vue&type=script&lang=ts"
export * from "./ButtonRed.vue?vue&type=script&lang=ts"

import "./ButtonRed.vue?vue&type=style&index=0&id=6fdbba67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdbba67"]])

export default __exports__